// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mFA-6","badges":"styles_badges__Y_4rj"};